import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Spiner } from "../../components/spinner/Spiner";
import TableList, { GridCol, GridRow } from "../../components/table/TableList"
import companiesQuery from "../../firestore/Companies.query";
import systemParametersQuery from "../../firestore/SystemParameters.query";
import { OptionContract, nowDate } from "../../model/OptionContract";
import { convertDateToString } from "../../utility/ConvertUtily";
import { Company, initialCompany } from "../../model/Companies";
import { auth } from "../../firebase";
import { alertOpen, AlertValue } from "../../features/alert.slice";
import { ConstMessage } from "../../config/const";
import { isOptionActive } from "../../controller/OptionController";

export const OptionContractSettingPage = () => {

  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [isLoad, setIsLoad] = useState(true);
  const [optionList, setOptionList] = useState<OptionContract[]>([]);
  const [company, setCompany] = useState<Company>(initialCompany);

  // ログイン中の団体情報
  const currentUser = auth.currentUser;
  const tenantId = currentUser?.tenantId;

  useEffect(() => {
    const f = async () => {
      try {
      setIsLoad(true);
      // 団体情報の取得
      const company = await companiesQuery.getCompany(tenantId!);
      setCompany(company);
      // 団体のオプション契約を取得
      const options = await companiesQuery.getOptionContractList(tenantId!);
      // マスタのオプション契約を取得
      const masterOptionData = await systemParametersQuery.getOptionContract();
      let optionResult: OptionContract[] = [];
      const masterOptionKeys = Object.keys(masterOptionData);
      for (let i = 0; i < masterOptionKeys.length; i++) {
        const key = masterOptionKeys[i];
        if (masterOptionData[key].status) {
          let option: OptionContract | undefined;
          option = options.find((option) => option.optionId === masterOptionData[key].optionId);
          if (option) {
            option.sort = masterOptionData[key].sort;
          } else {
            option = {
              id: "",
              optionId: masterOptionData[key].optionId,
              optionName: masterOptionData[key].optionName,
              status: false,
              applicableStartDate: null,
              applicableFinishDate: null,
              sort: masterOptionData[key].sort,
            };
          }
      
          // ステータスが有効のオプションだけ追加する
          if (isOptionActive(option)) {
            optionResult.push(option);
          }
        }
      }
      setOptionList(optionResult);
      setIsLoad(false);
    } catch (err: any) {
    console.error(err);
    setIsLoad(false);
    dispatch(alertOpen(AlertValue(ConstMessage.ERR_FAILED_GET_DATA, "danger")));
    }
  };
    f();
  }, [isOpen]);

  const statusName = (status: boolean, startDate: Date | null, finishDate: Date | null) => {
    if(status && (
      (startDate !== null && finishDate !== null && startDate <= nowDate && finishDate >= nowDate && startDate <= finishDate) || 
      (startDate === null && finishDate === null) || 
      (finishDate === null && startDate !== null && startDate <= nowDate) || 
      (startDate === null && finishDate !== null && finishDate >= nowDate)))
    {
      return <span className={"text-green-700 font-bold"}>有効</span>;
    }else if(status && startDate !== null && startDate > nowDate){
      return <span className={"text-yellow-400 font-bold"}>有効（開始待ち）</span>;
    }
  }

  const columns: GridCol[] = [
    {
      field: "optionName",
      headerName: "オプション名",
      style: "w-3/12",
    },
    {
      field: "status",
      headerName: "契約状況",
      style: "w-2/12",
    },
    {
      field: "applicableStartDate",
      headerName: "開始日",
      style: "w-2/12",
    },
    {
      field: "applicableFinishDate",
      headerName: "終了日",
      style: "w-2/12",
    },
    {
      field: "control",
      headerName: "",
      style: "w-1/12",
      sort: false
    },
  ];

  const rowList: GridRow[] = optionList.map<GridRow>((item, index) => {
    return {
      rowData: {
        optionName: item.optionName,
        status: statusName(item.status, item.applicableStartDate, item.applicableFinishDate),
        applicableStartDate: item.applicableStartDate !== null ? convertDateToString(item.applicableStartDate) : "",
        applicableFinishDate: item.applicableFinishDate !== null ? convertDateToString(item.applicableFinishDate) : "",
      }
    }
  });

  return(
    <div className="h-full">
      <div className="flex items-center space-x-4 px-6 pt-6 pb-4 justify-between">
        <h2 className="flex text-xl font-semibold text-gray-900">オプション契約詳細</h2>
      </div>
      {isLoad === true ? <Spiner /> :(
        <div className={"px-6"}>
          <TableList
            header={false}
            footer={false}
            defaultSortKey={"sort"}
            sort={false}
            gridCol={columns}
            gridRow={rowList}
          />
        </div>
      )}
    </div>
  );
}